export default "__VITE_ASSET__867Iuy7f__"